import { render, staticRenderFns } from "./CName.vue?vue&type=template&id=b07cb64c&scoped=true&"
import script from "./CName.vue?vue&type=script&lang=js&"
export * from "./CName.vue?vue&type=script&lang=js&"
import style0 from "./CName.vue?vue&type=style&index=0&id=b07cb64c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07cb64c",
  null
  
)

export default component.exports